import { Opacity } from "@mui/icons-material";
import { CircularProgress, colors, styled, Switch } from "@mui/material";

export const IOSSwitch = styled(({ label = "Label", ...props }) => (
  <div style={{ position: "relative", display: "inline-block" }}>
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
  </div>
))(({ theme, label }) => ({
  width: 120,
  height: 36,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 0, // ❌ remove margin that offsets thumb
    top: "50%", // ✅ vertical center
    transform: "translate(8px ,-50%)",
    "& .MuiSwitch-thumb": {
      backgroundColor: "#ffffff", // ✅ ball when checked
      opacity: 1,
    },
    "&.Mui-checked": {
      transform: "translate(85px, -50%)",
      paddingLeft:"4px", // move right + keep centered
      "& + .MuiSwitch-track": {
        backgroundColor: "#29CD60",
        opacity: 1,
        "&::before": {
          content: `"${label}"`,
          position: "absolute",
          left: "38%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          paddingRight:"4px",
          color: "#000000",
          fontSize: 14,
          fontWeight: 600,
          fontFamily: "Poppins",
        },
      },
    },
    "& + .MuiSwitch-track": {
      backgroundColor: "#191818",
      opacity: 1,
      "&::before": {
        content: `"${label}"`,
        position: "absolute",
        left: "65%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        color: "#444444",
        fontSize: 14,
        fontWeight: 600,
        fontFamily: "Poppins",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    width: 28,
    height: 28,
    padding: 0,
    backgroundColor: "#ffffff", // ✅ default white ball
    opacity: 1,
    borderRadius:"4px",
  },
  "& .MuiSwitch-track": {
    borderRadius: 4,
    position: "relative",
    opacity: 1,
  },
}));
